import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import "chartjs-adapter-date-fns";
import { BarChart2 } from "lucide-react";
import {
  Chart as ChartJS,
  LineElement, CategoryScale, LinearScale, PointElement,
  TimeScale, Tooltip, Legend, plugins,
} from "chart.js";
ChartJS.register(
  LineElement, CategoryScale, LinearScale,
  PointElement, TimeScale, Tooltip, Legend
);

export default function RealtimeHourlyChart() {
  const [dataJam, setDataJam] = useState([]);
  // const UPDATE_INTERVAL = 60000; // 1 menit (ubah ke 300000 = 5 menit jika ingin)

  useEffect(() => {
    const now = new Date();
    // const today = new Date(now.toLocaleString("en-US", {timeZone: "Asia/Jakarta"}));
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    // const today = new Date().toISOString().split("T")[0];
    const dataRef = ref(db, `dataHistoris/${today}`);

    const unsubscribe = onValue(dataRef, (snapshot) => {
      try {
        const raw = snapshot.val() || {};
        // const now = new Date();

        // // ambil awal hari (00:00 hari ini)
        // const startOfDay = new Date(
        //   now.getFullYear(),
        //   now.getMonth(),
        //   now.getDate(),
        //   0, 0, 0, 0
        // ).getTime();

        // // ambil akhir hari (23:59)
        // const endOfDay = new Date(
        //   now.getFullYear(),
        //   now.getMonth(),
        //   now.getDate(),
        //   23, 59, 59, 999
        // ).getTime();

        const cleaned = Object.values(raw)
          // .map((d) => ({
          //   ...d,
          //   timestamp: new Date(d.timestamp).getTime(),
          // }))

          // // FILTER HANYA HARI INI
          // .filter(
          //   (d) => d.timestamp >= startOfDay && d.timestamp <= endOfDay
          // )

          .map((d) => ({
            ...d, timestamp: Number(d.timestamp),
          }))
          .sort((a, b) => a.timestamp - b.timestamp)
          // limit data (max 35 data)
          .slice(-35);

        setDataJam(cleaned);
      } catch (err) {
        console.error("Realtime error:", err);
      }
    });

    // fetch awal
    // fetchData();

    // // polling semi realtime
    // const interval = setInterval(fetchData, UPDATE_INTERVAL);
    // return () => clearInterval(interval);
    return () => unsubscribe();
  }, []);

  const SENSOR_KEYS = {
    suhu: {label: "Suhu", unit: "°C", color: "#EF4444"},
    kelembapan: {label: "Kelembapan", unit: "%", color: "#3B82F6"},
    co2: {label: "Gas CO₂", unit: "ppm", color: "#10B981"},
    co: {label: "Asap", unit: "ppm", color: "#6B7280"},
    kebisingan: {label: "Kebisingan", unit: "dB", color: "#8B5CF6"},
    cahaya: {label: "Intensitas Cahaya",unit: "lux", color: "#F59E0B"},
  };

  const chartData = {
    datasets: Object.entries(SENSOR_KEYS).map(([key, config]) => ({
      label: `${config.label} (${config.unit})`,
      data: dataJam.map((d) => ({
        x: d.timestamp, // timestamp NUMBER
        y: Number(d[key] ?? (d.sensor && d.sensor[key])) || 0,
        // y: Number(d[key]) || 0,
      })),
      borderColor: config.color,
      backgroundColor: config.color + "22",
      tension: 0.4,
      spanGaps: true,
      pointRadius: 3,
      pointHoverRadius:5,
      borderWidth: 2,
    })),
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {usePointStyle: true, pointStyle: "circle", font: {size: 12}, padding: 12},
      },
      tooltip: {
        backgroundColor: "#1e293b",
        titleColor: "#94a3b8",
        bodyColor: "#f1f5f9",
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: (ctx) =>
            `${ctx.dataset.label}: ${ctx.parsed.y}`,
        },
      },
    },
    scales: {
      x: {
        grid: {color: "#f1f5f9"},
        ticks: {color: "#94a3b8", font: {size: 11}},
        type: "time",
        time: {
          parser: "t",
          unit: "minute",
          displayFormats: {
            minute: "HH:mm",
          },
        },
        ticks: {
          source: "data",
          autoSkip: true,
          maxTicksLimit: 8,
        },
        title: {
          display: true,
          text: "Waktu",
        },
      },
      y: {
        grid: {color: "#f1f5f9"},
        ticks: {color: "#94a3b8", font: {size: 11}},
        beginAtZero: true,
        title: {
          display: true,
          text: "Nilai Sensor",
        },
      },
    },
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 border border-gray-200 w-full">
      <div className="flex items-center gap-2 mb-5">
        <BarChart2 size={18} className="text-blue-600"/>
        <h3 className="text-xl font-semibold text-gray-700">
          Grafik Sensor Realtime per Jam
        </h3>
      </div>
      <div className="h-[290px] sm:h-[370px]">
        <Line 
          data={chartData} 
          options={{
            ...chartOptions,
            maintainAspectRatio: false
          }} 
          height={120}
        />
      </div>
    </div>
  );
}